/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {IBetWinData, IGameData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";

export class StarStruckServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseBetWins(rawData:IGameData):IBetWinData[] {
        switch(GameConfig.instance.BET_WIN_MODE) {
            case BetWinMode.BET_LINE:
                return this.parseBetLineData(rawData.betLineWins!);
            case BetWinMode.BET_WAY:
                return rawData.betWayWins!;
            default:
                debugger;
                throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
    }

    private parseBetLineData(betLineWins:IBetWinData[]):IBetWinData[] {
        let temp:IBetWinData[] = [];
        betLineWins.forEach((betlineWin:IBetWinData)=>{
            if(betlineWin.amount>0){
                temp.push(betlineWin);
            }
        });
        return temp;
    }
}